import { uploadedFileSchema } from '@terra/shared-authorization';
import { z } from 'zod';

export const COPILOT_FEEDBACK_SCREENSHOT_MAX_SIZE_BYTES = 5 * 1024 * 1024;
export const COPILOT_FEEDBACK_SCREENSHOT_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
] as const;

export const SubmitFeedbackRequestSchema = z.object({
  applicationId: z.string(),
  threadId: z.string(),
  traceId: z.string(),
  rating: z.enum(['positive', 'negative']).optional(),
  feedback: z.string().max(2000).optional(),
  screenshotPath: z.string().optional(),
  screenshot: uploadedFileSchema({
    mimeTypes: COPILOT_FEEDBACK_SCREENSHOT_MIME_TYPES,
    maxFileSizeBytes: COPILOT_FEEDBACK_SCREENSHOT_MAX_SIZE_BYTES,
  }).optional(),
});

export const SubmitFeedbackSuccessResponseSchema = z.object({
  success: z.literal(true),
});

export const SubmitFeedbackErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  details: z.array(z.any()).optional(),
});

export const SubmitFeedbackResponseSchema = z.union([
  SubmitFeedbackSuccessResponseSchema,
  SubmitFeedbackErrorResponseSchema,
]);
